import React, { FunctionComponent } from 'react'
import styles from './LoadingPage.module.css'
import { LoadingDots } from '../LoadingDots/LoadingDots'

const LoadingPage: FunctionComponent = () => {
  return (
    <div className={styles.spinnerContainer}>
      <div className='empty loading'>
        <LoadingDots />
      </div>
    </div>
  )
}
export default LoadingPage
